/**
 * One shake of an element (a refused password, a PIN that does not match): Motion's imperative `animate`, loaded the
 * first time a shake is asked for, so the Panel's entry does not carry Motion's animation engine for it.
 */
type ShakeKeyframes = Readonly<{ transform: readonly string[] }>;
type ShakeOptions = Readonly<{ duration: number; ease?: 'easeInOut' }>;

/**
 * One refusal in place: 0, −7, 6, −4, 2, 0 px over 0.38 s on the `translate` property, so it composes with the element's
 * own transform (a handle's counter-scale, a lifted place's scale and lean). It needs no engine.
 */
export function shakeInPlace(element: Element | null | undefined): void {
  if (!(element instanceof HTMLElement) || typeof element.animate !== 'function') return;
  element.animate([0, -7, 6, -4, 2, 0].map((x) => ({ translate: `${x}px 0` })), { duration: 380, easing: 'ease-in-out' });
}

let engine: Promise<typeof import('./shake-motion')> | null = null;

export function shake(element: Element, keyframes: ShakeKeyframes, options: ShakeOptions): void {
  engine ??= import('./shake-motion').catch((error: unknown) => { engine = null; throw error; });
  void engine.then(({ animate }) => {
    // The element may have left while the engine loaded.
    if (element.isConnected) void animate(element, { transform: [...keyframes.transform] }, options);
  }, () => undefined);
}
